import styled from 'styled-components';
import SafetyCheckIconSvg from './safety-check.svg';

const SafetyCheckIcon = styled(SafetyCheckIconSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.5rem'};
  height: ${props => props.height || ''};
  fill: ${props => props.fill || '#647a97'};
  transform: ${props => props.transform};
`;

export default SafetyCheckIcon;

